import { render, staticRenderFns } from "./Imgtd.vue?vue&type=template&id=faa14e60&scoped=true"
import script from "./Imgtd.vue?vue&type=script&lang=js"
export * from "./Imgtd.vue?vue&type=script&lang=js"
import style0 from "./Imgtd.vue?vue&type=style&index=0&id=faa14e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa14e60",
  null
  
)

export default component.exports